import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

const Dropdown = styled(motion.div)<{ $maxWidth: number | string; $maxHeight: string }>`
  ${({ $maxWidth, $maxHeight }) => css`
    position: absolute;
    z-index: 1;
    background-color: white;
    border-radius: 0.2rem;
    max-width: ${typeof $maxWidth === 'number' ? `${$maxWidth}rem` : $maxWidth};
    max-height: ${$maxHeight};
    width: 100%;
    box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.2);
    margin-top: 0.2rem;
    overflow-y: auto;
  `}
`

export default {
  Dropdown,
}
